<div class="modal-header">
    <h6 class="modal-title pull-left">{{title}}</h6>
    <button *ngIf="type != 'error'" type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    
    </button>
</div>
<div class="modal-body">
    <p class="mb-1 text-center" [style]="'color: ' + getIconColor()">
        <i [class]="'fa ' + getIcon() + ' fa-3x'"></i>
    </p>
    <p class="text-muted mb-0 text-justify pt-2 pe-2 ps-2" [innerHTML]="getMessageFormated()"></p>

    <div *ngIf="type == 'OTP'" class="mt-1 p-2">
        <form #formRef="ngForm">
            <div class="form-group">
                <p for="confirmInput" class="text-muted mb-1">{{inputLabel}}</p>
                <input type="text" name="confirmInput" (keyup.enter) = "onDone()" [(ngModel)]="inputFieldValue" class="form-control"
                    id="confirmInput" required>
            </div>
        </form>
    </div>

</div>
<div class="modal-footer">
    <div class="w-100">
        <button *ngIf="type == 'OTP'" type="button" class="btn btn-primary-alert" (click)="onRetry()" [disabled]="timmer && timmer.counter > 0">{{(timmer && timmer.counter > 0) ? 'Reintentar ' + (timmer.counter | formatTime) : retryBtnName}}</button>
        <button [hidden]="!closeBtnName" type="button" class="btn btn-default-alert float-end" (click)="onCancel()">{{closeBtnName}}</button>
        <button [disabled]="!inputFieldValue && type == 'OTP'" [hidden]="!doneBtnName" type="button" class="btn btn-primary-alert float-end mx-2" (click)="onDone()">{{doneBtnName}}</button>
    </div>
</div>